import { BaseActionObject, StateNodeConfig, assign } from "xstate4"
import {
  Context,
  StudyPlanTargets,
  Transitions,
  ViewBreakSchema
} from "../../types"

export const viewBreakDrawerState: StateNodeConfig<
  Context,
  ViewBreakSchema,
  Transitions,
  BaseActionObject
> = {
  entry: assign<Context>({
    viewBreakDrawer: true
  }),
  exit: assign<Context>({
    viewBreakDrawer: false,
    selectedLessonId: null,
    selectedSectionId: null,
    selectedBreakType: null
  }),
  initial: "idle",
  states: {
    idle: {
      on: {
        TOGGLE_BREAK_AFTER_SECTION: [
          {
            target:
              "#StudyPlan.teacher_view.toggle_break_after_section_transition",
            cond: (ctx, _evt) =>
              ctx.currentTarget === StudyPlanTargets.TeacherView
          },
          {
            target:
              "#StudyPlan.edit_plan.toggle_break_after_section_transition",
            cond: (ctx, _evt) => ctx.currentTarget === StudyPlanTargets.Edit
          }
        ],
        TOGGLE_BREAK_BEFORE_SECTION: [
          {
            target:
              "#StudyPlan.teacher_view.toggle_break_before_section_transition",
            cond: (ctx, _evt) =>
              ctx.currentTarget === StudyPlanTargets.TeacherView
          },
          {
            target:
              "#StudyPlan.edit_plan.toggle_break_before_section_transition",
            cond: (ctx, _evt) => ctx.currentTarget === StudyPlanTargets.Edit
          }
        ],
        TOGGLE_BREAK_AFTER_LESSON: [
          {
            target:
              "#StudyPlan.teacher_view.toggle_break_after_lesson_transition",
            cond: (ctx, _evt) =>
              ctx.currentTarget === StudyPlanTargets.TeacherView
          },
          {
            target: "#StudyPlan.edit_plan.toggle_break_after_lesson_transition",
            cond: (ctx, _evt) => ctx.currentTarget === StudyPlanTargets.Edit
          }
        ],
        TOGGLE_BREAK_BEFORE_LESSON: [
          {
            target:
              "#StudyPlan.teacher_view.toggle_break_before_lesson_transition",
            cond: (ctx, _evt) =>
              ctx.currentTarget === StudyPlanTargets.TeacherView
          },
          {
            target:
              "#StudyPlan.edit_plan.toggle_break_before_lesson_transition",
            cond: (ctx, _evt) => ctx.currentTarget === StudyPlanTargets.Edit
          }
        ]
      }
    }
  },
  on: {
    CLOSE: [
      {
        target: "#StudyPlan.teacher_view.idle",
        cond: (ctx, _evt) => ctx.currentTarget === StudyPlanTargets.TeacherView
      },
      {
        target: "#StudyPlan.edit_plan"
      }
    ]
  }
}
